module.exports = __webpack_public_path__ + "static/media/ΛΑΓΟΣ ΧΕΛΩΝΑ (ΟΝΓ).76c8e6d3.vtt";